var defaultBreakpoints = {
  large: 768
};
export var defaultDesktopBreakpoint = defaultBreakpoints.large;